import { composeProps, createAction, createPropsExtender } from '@mews/framework';
import { ApplicationState } from '@mews-commander/types';
import { Cashier } from '@mews-commander/data-access';
import { createOptionsSelector } from '@mews-commander/utils';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import parentSelector from '../selector';
import prefix from '../prefix';
import { createCurrentEnterpriseScopedAction } from './scopedActionCreators';
import { createScopedEntitiesReducer, createScopedBaseEntitySelectors } from './utils';

export const NAME = 'cashiers';

const CASHIERS_LOADED = prefix('CASHIERS_LOADED');

export const [getCashiers, getCashiersByIds, getCashiersByOwnerId, getCashier] = createScopedBaseEntitySelectors<
    ApplicationState,
    Cashier,
    typeof NAME,
    'enterpriseId'
>(parentSelector, NAME, 'enterpriseId');

export const getCurrentEnterpriseCashier = composeProps(
    getCashier,
    createPropsExtender('enterpriseId', getCurrentEnterpriseId)
);

export const setCashiers = (cashiers: Cashier[], enterpriseId: string) =>
    createAction(CASHIERS_LOADED, { entities: cashiers }, { scope: enterpriseId });
export const setCurrentEnterpriseCashiers = (cashiers: Cashier[]) =>
    createCurrentEnterpriseScopedAction(CASHIERS_LOADED, { entities: cashiers });

export const cashiersReducer = createScopedEntitiesReducer({
    FETCH_SUCCESS: CASHIERS_LOADED,
});

export const getCashierOptions = createOptionsSelector(getCashiers, { value: 'id', label: 'name' });
